export default {
  title: 'Pagamento',
  description: 'Todas as transações são seguras e encriptadas',
  show_more_payment_methods: 'Mostrar mais métodos de pagamento',
  express_checkout_divider: 'ou',
};
